var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 35.9877C53 44.8175 45.8421 51.9755 37.0123 51.9755C34.987 51.9755 33.0496 51.5989 31.2664 50.9119C30.9404 50.7863 30.7773 50.7235 30.6477 50.6936C30.5202 50.6642 30.4279 50.6519 30.2972 50.6469C30.1642 50.6418 30.0184 50.6569 29.7267 50.6871L20.0945 51.6827C19.1762 51.7777 18.717 51.8251 18.4461 51.6599C18.2102 51.516 18.0495 51.2756 18.0068 51.0026C17.9577 50.6892 18.1771 50.283 18.6159 49.4707L21.6924 43.7762C21.9458 43.3073 22.0725 43.0728 22.1299 42.8473C22.1865 42.6247 22.2002 42.4641 22.1821 42.235C22.1638 42.0031 22.062 41.7012 21.8585 41.0974C21.3177 39.493 21.0245 37.7746 21.0245 35.9877C21.0245 27.158 28.1825 20 37.0123 20C45.8421 20 53 27.158 53 35.9877Z",
    stroke: "#243677",
    strokeWidth: 3.76182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 34,
    stroke: "#243677",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.fa8d50c03f20e1cd779f9d4e5fc808f9.svg";
export { ForwardRef as ReactComponent };